import { Flex, MenuProps } from 'antd';
import React from 'react';
import { ReactComponent as PersonFill } from 'assets/icons/PersonFill.svg';
import { ReactComponent as ReadFilled } from 'assets/icons/ReadFilled.svg';
import { FileFilled } from '@ant-design/icons';
import { Role, User } from '_business/types/User';

export type MenuItem = Required<MenuProps>['items'][number];

export const navigationMenus = [
  {
    key: '/',
    label: 'Mes projets',
    icon: <FileFilled className="!h-4 !w-4" />,
    roles: [Role.CUSTOMER, Role.MANAGER],
  },
  {
    key: '/clients',
    label: 'Mes clients',
    icon: <FileFilled className="!h-4 !w-4" />,
    roles: [Role.PARTNER],
  },
  {
    key: '/profile',
    label: 'Mon profil',
    icon: <PersonFill className="!h-4 !w-4" />,
    roles: [Role.CUSTOMER, Role.PARTNER, Role.MANAGER],
  },
  {
    key: '/ressources',
    label: 'Mes ressources',
    icon: <ReadFilled className="!h-4 !w-4" />,
    roles: [Role.CUSTOMER],
  },
];

const navigationConfig = (
  onClick?: (e: any) => void,
  user?: User,
): MenuItem[] =>
  navigationMenus
    .filter((menu) => menu.roles.includes(user?.role || Role.CUSTOMER))
    .map((menu) => {
      return {
        ...menu,
        onClick,
        icon: (
          <Flex style={{ width: 24 }} justify={'center'}>
            {menu.icon}
          </Flex>
        ),
      };
    });

export default navigationConfig;
